module.exports = __webpack_public_path__ + "static/media/image.11caf111.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/overlay-icons/image.svg
// module id = 845
// module chunks = 0